import { Component, OnInit } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";

@Component({
  selector: "app-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
})
export class BreadcrumbsComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit(): void {

    this.router.events
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          if (event.url.includes("/distributions/doz/view/")) {
            this.router.config[0].children?.forEach(child => {
              // @ts-ignore
              if (child.path.includes("distributions/doz")) {
                child.children?.forEach(child2 => {
                  if (child2.title === "Розподіл") {
                    // @ts-ignore
                    child2.data.breadcrumb.alias = "Розподіл №" + event.url.split("/distributions/doz/view/")[1];
                  }
                });
              }
            });
          }
        }
      });
  }
}
